const routes = [
  {
    path: "/",
    component: () => import("layouts/IndexLayout.vue"),
    children: [{ path: "", component: () => import("pages/Index.vue") }],
  },
  {
    path: "/registergate",
    component: () => import("layouts/IndexLayout.vue"),
    children: [{ path: "", component: () => import("pages/RegisterGate.vue") }],
  },
  {
    path: "/register",
    component: () => import("layouts/IndexLayout.vue"),
    children: [{ path: "", component: () => import("pages/Register.vue") }],
  },
  {
    path: "/registerOutsourcee",
    component: () => import("layouts/IndexLayout.vue"),
    children: [
      { path: "", component: () => import("pages/RegisterOutsourcee.vue") },
    ],
  },
  {
    path:'/registerBusinessSupport',
    component: () => import ('layouts/IndexLayout.vue'),
    children:[{path:'',component:()=>import('pages/RegisterBusinessSupport')}]
  },
  {
    path: "/forgotPassword",
    component: () => import("layouts/IndexLayout.vue"),
    children: [
      { path: "", component: () => import("pages/ForgotPassword.vue") },
    ],
  },
  {
    path: "/activateAccount",
    component: () => import("layouts/IndexLayout.vue"),
    children: [
      { path: "", component: () => import("pages/ActivateAccount.vue") },
    ],
  },
  // Post-auth
  {
    path: "/dashboard",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      { path: "", component: () => import("pages/app/Dashboard.vue") },
    ],
  },
  {
    path: "/profile",
    component: () => import("layouts/MainLayout.vue"),
    children: [{ path: "", component: () => import("pages/app/Profile.vue") }],
  },
  {
    path: "/availability",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      { path: "", component: () => import("pages/app/Availability.vue") },
    ],
  },
  {
  	path:'/availability/:supportId',
  	component:()=>import('layouts/MainLayout.vue'),
  	children:[{path:'',component:()=>import('pages/app/OmManageAvailability.vue')}]
  },
  {
    path: "/assignments",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      { path: "", component: () => import("pages/app/Assignments.vue") },
    ],
  },
  {
    path: "/assignments/:id",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("pages/app/Assignments.vue"),
      },
    ],
  },
  {
    path: "/assignmentBilling",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      { path: "", component: () => import("pages/app/AssignmentBilling.vue") },
    ],
  },
  {
    path: "/subOutsourceeOverview",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("pages/app/SubOutsourceeOverview.vue"),
      },
    ],
    meta: { billingManager: true },
  },
  {
    path: "/networking",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      { path: "", component: () => import("pages/app/Networking.vue") },
    ],
  },
  {
    path: "/manageNetworking",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      { path: "", component: () => import("pages/app/ManageNetworking.vue") },
    ],
  },
  {
    path: "/draftAssignments",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      { path: "", component: () => import("pages/app/DraftAssignments.vue") },
    ],
  },
  {
    path: "/directory",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      { path: "", component: () => import("pages/app/DirectoryV2.vue") },
    ],
  },
  {
    path: "/directory/:id",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      { path: "", component: () => import("pages/app/DirectoryV2.vue") },
    ],
  },
  {
    path:'/viewOutsourcee/:id',
    component:()=>import('layouts/MainLayout.vue'),
    children:[{path:'',component:()=>import('pages/app/ViewOutsourcee.vue')}]
  },
  {
  	path:'/freelancerId/:supportId',
  	component:()=>import('layouts/MainLayout.vue'),
  	children:[{path:'',component:()=>import('pages/app/ViewOutsourcee.vue')}]
  },
  {
  	path:'/freelancerProfile/:supportId',
  	component:()=>import('layouts/PublicLayout.vue'),
  	children:[{path:'',component:()=>import('pages/app/ViewOutsourcee.vue')}]
  },
  {
  	path:'/reference/:supportId',
  	component:()=>import('layouts/PublicLayout.vue'),
  	children:[{path:'',component:()=>import('pages/app/ProvideReference.vue')}]
  },
  {
  	path:'/approveTestimonial/:supportId',
  	component:()=>import('layouts/PublicLayout.vue'),
  	children:[{path:'',component:()=>import('pages/app/ApproveTestimonial.vue')}]
  },
  {
  	path:'/thank-you-for-the-reference',
  	component:()=>import('layouts/PublicLayout.vue'),
  	children:[{path:'',component:()=>import('pages/app/Thank-you-for-the-reference.vue')}]
  },
  {
    path:'/bspDirectory',
    component:()=>import("layouts/MainLayout.vue"),
    children:[
      {path:'',component:()=>import('pages/app/bspDirectory.vue')}
    ]
  },
  {
    path:'/bspReferralsReceived',
    component:()=>import('layouts/MainLayout.vue'),
    children:[{path:'',component:()=>import('pages/app/bspReferralsReceived')}]
  },
  {
    path:'/partnership',
    component:()=>import('layouts/MainLayout.vue'),
    children:[{path:'',component:()=>import('pages/app/Partnership.vue')}]
  },
  {
    path:'/bspReferrals',
    component:()=>import('layouts/MainLayout.vue'),
    children:[{path:'',component:()=>import('pages/app/bspReferrals.vue')}]
  },
  {
    path: "/clients",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      { path: "", component: () => import("pages/app/ClientsV2.vue") },
    ],
  },
  {
    path: "/clients/:id",
    component: () => import("layouts/MainLayout.vue"),
    children: [{ path: "", component: () => import("pages/app/Clients.vue") }],
  },
  {
    path: "/pendingAssignments",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      { path: "", component: () => import("pages/app/PendingAssignments.vue") },
    ],
  },
  {
    path: "/billing",
    component: () => import("layouts/MainLayout.vue"),
    children: [{ path: "", component: () => import("pages/app/Billing.vue") }],
  },
  {
    path: "/billing/:id",
    component: () => import("layouts/MainLayout.vue"),
    children: [{ path: "", component: () => import("pages/app/Billing.vue") }],
  },
  {
    path: "/businessSupport",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      { path: "", component: () => import("pages/app/BusinessSupportV2.vue") },
    ],
  },
  {
    path: "/manageOpenJobs",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      { path: "", component: () => import("pages/app/ManageOpenJobs.vue") },
    ],
  },
  {
    path: "/openJobs",
    component: () => import("layouts/MainLayout.vue"),
    children: [{ path: "", component: () => import("pages/app/OpenJobs.vue") }],
  },
  {
    path: "/csmOpenJobs",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      { path: "", component: () => import("pages/app/CsmOpenJobs.vue") },
    ],
  },
  {
    path: "/enquiries",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      { path: "", component: () => import("pages/app/Enquiries.vue") },
    ],
  },
  {
    path: "/document/:doc",
    component: () => import("layouts/MainLayout.vue"),
    children: [{ path: "", component: () => import("pages/app/Document.vue") }],
  },
  {
    path: "/chats",
    component: () => import("layouts/MainLayout.vue"),
    children: [{ path: "", component: () => import("pages/app/Chats.vue") }],
  },
  {
    path: "/subAccounts/:id",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      { path: "", component: () => import("pages/app/SubAccounts.vue") },
    ],
  },
  // Outsourcee
  {
    path: "/outsourcee/elevatorPitch",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("pages/app/outsourcee/elevatorPitch.vue"),
      },
    ],
  },
  {
    path: "/outsourcee/proof/:type",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      { path: "", component: () => import("pages/app/outsourcee/proofs") },
    ],
  },
  {
    path: "/outsourcee/sign/:type",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      { path: "", component: () => import("pages/app/outsourcee/sign") },
    ],
  },
  {
    path: "/suboutsourcees",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("pages/app/outsourcee/subOutsourcees"),
      },
    ],
  },
  // Admin
  {
    path: "/settings",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      { path: "", component: () => import("pages/app/admin/Settings.vue") },
    ],
    meta: { admin: true },
  },
  {
    path: "/settings/services",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("pages/app/admin/SettingsServices.vue"),
      },
    ],
    meta: { admin: true },
  },
  {
    path: "/settings/outsourceeRegister",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      {
        path: "",
        component: () =>
          import("pages/app/admin/SettingsOutsourceeRegister.vue"),
      },
    ],
    meta: { admin: true },
  },
  {
    path: "/settings/terms",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("pages/app/admin/SettingsTerms.vue"),
      },
    ],
    meta: { admin: true },
  },
  {
    path: "/settings/privacy",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("pages/app/admin/SettingsPrivacy.vue"),
      },
    ],
    meta: { admin: true },
  },
  {
    path: "/settings/opsRulesPerks",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("pages/app/admin/SettingsOpsRulesPerks.vue"),
      },
    ],
    meta: { admin: true },
  },
  {
    path: "/settings/outsourceeTermsAndConditions",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("pages/app/admin/SettingsOutsourceeTerms.vue"),
      },
    ],
    meta: { admin: true },
  },
  {
    path: "/settings/admins",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("pages/app/admin/SettingsAdmins.vue"),
      },
    ],
    meta: { admin: true },
  },
  {
    path:'/settings/talentTracking',
    component:()=>import('layouts/MainLayout.vue'),
    children:[{path:'',component:()=>import('pages/app/admin/SettingsTalentTracking.vue')}]
  },
  {
    path: "/settings/users",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("pages/app/admin/SettingsUsers.vue"),
      },
    ],
    meta: { admin: true },
  },
  {
    path: "/settings/businesses",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("pages/app/admin/SettingsBusinesses.vue"),
      },
    ],
    meta: { admin: true },
  },
  {
    path: "/logout",
    component: () => import("layouts/IndexLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("pages/app/Logout.vue"),
      },
    ],
  },
  // Always leave this as last one,
  // but you can also remove it
  {
    path: "/:catchAll(.*)*",
    component: () => import("pages/ErrorNotFound.vue"),
  },
];

export default routes;
